// src/serviceWorkerRegistration.js

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );
  
  export function register(config) {
    // Registra il Service Worker solo in produzione, se supportato
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
      // Se PUBLIC_URL non corrisponde all'origin attuale, esci
      if (publicUrl.origin !== window.location.origin) {
        return;
      }
  
      // All'avvio, proviamo a registrare il SW
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
        if (isLocalhost) {
          // Se siamo in localhost, facciamo controlli aggiuntivi
          checkValidServiceWorker(swUrl, config);
        } else {
          // Altrimenti, registrazione standard
          registerValidSW(swUrl, config);
        }
      });
    }
  }
  
  function registerValidSW(swUrl, config) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Ogni 10 secondi forziamo un check per aggiornamenti
        setInterval(() => {
          registration.update();
        }, 10000);
  
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              // Se c'è già un controller SW, allora è un update
              if (navigator.serviceWorker.controller) {
                console.log(
                  'Nuovi contenuti disponibili e saranno utilizzati ' +
                  'quando tutte le schede saranno chiuse.'
                );
                if (config && config.onUpdate) {
                  config.onUpdate(registration);
                }
              } else {
                // Altrimenti, nuovo contenuto è già in cache
                console.log('Contenuto memorizzato per l\'uso offline.');
                if (config && config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error('Errore durante la registrazione del Service Worker:', error);
      });
  }
  
  function checkValidServiceWorker(swUrl, config) {
    fetch(swUrl, {
      headers: { 'Service-Worker': 'script' },
    })
      .then((response) => {
        const contentType = response.headers.get('content-type');
        // Se non troviamo il file service-worker.js o non è JS, unregister e ricarica
        if (
          response.status === 404 ||
          (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
          navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
              window.location.reload();
            });
          });
        } else {
          // Altrimenti, registriamo normalmente
          registerValidSW(swUrl, config);
        }
      })
      .catch(() => {
        console.log(
          'Nessuna connessione internet trovata. ' +
          'L\'app è in modalità offline.'
        );
      });
  }
  
  export function unregister() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.unregister();
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  }
  